import { Grid, withStyles, WithStyles } from '@material-ui/core'
import { Fragment, FC, useEffect, useState, createRef } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { openDialog } from '../../actions/dialogs'
import {
  changePassword,
  updateUserInformation,
  logout
} from '../../actions/users'
import Container from '../../components/Container'
import { objectNotEmpty } from '../../libs/objects'
import {
  selectIsAdminUser,
  selectUserAttributes,
  selectUserIsAuthenticated
} from '../../selectors/users'
import { UserAttributes } from '../../services/auth/types'
import { profileStyles } from '../../styles'
import { StateInterface } from '../../types/states'
import { bindSubmitActionToPromise } from '../../utils/forms'

const mapStateToProps = (state: StateInterface) => {
  const stateUserAttributes = selectUserAttributes(state)
  return {
    isAdmin: selectIsAdminUser(state),
    isAuthenticated: selectUserIsAuthenticated(state),
    userAttributes: objectNotEmpty<UserAttributes>(stateUserAttributes)
      ? stateUserAttributes
      : undefined
  }
}

type PropsFromState = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateUserInfo: bindSubmitActionToPromise(dispatch, updateUserInformation),
  changeUserPassword: bindSubmitActionToPromise(dispatch, changePassword),
  openDialogAction: (id: string) => dispatch(openDialog(id)),
  logoutUser: () => dispatch(logout())
})

type DispatchProps = ReturnType<typeof mapDispatchToProps>

type MessageProps = PropsFromState &
  DispatchProps &
  WithTranslation &
  WithStyles

const Messages: FC<MessageProps> = ({
  isAdmin,
  isAuthenticated,
  classes,
  userAttributes,
  t
}: MessageProps) => {
  console.log('Chat Init')
  let inputRef = createRef()
  const [inbox, setIndox] = useState<any>(undefined)

  /* eslint-disable react-hooks/rules-of-hooks */
  useEffect(() => {
    //console.log('inbox', inbox)
    if (inbox) {
      inbox?.mount(inputRef)
      console.log('inbox mounted')
    }
  }, [inbox])

  /* eslint-disable react-hooks/rules-of-hooks */
  useEffect(() => {
    ;(async () => {
      if (userAttributes && userAttributes.email) {
        if (window.talkSession) {
          setIndox(window.talkSession.createInbox())
        }
      }
    })()

    return () => {
      // this now gets called when the component unmounts
    }
  }, [userAttributes])

  return (
    <Fragment>
      <Container>
        <Grid container justify='space-around' style={{ paddingTop: '24px' }}>
          <Grid container direction='row' justify='space-evenly'>
            <Grid item md={12} lg={12} xl={10} xs>
              {isAuthenticated && (
                <div
                  style={{ height: '500px' }}
                  className='inbox-container'
                  ref={(e) => (inputRef = e as any)}
                >
                  Loading...
                </div>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(profileStyles)(withTranslation()(Messages)))
